export const renderImage = (assetUrl: string, image: string) => {
  if (image.charAt(0) !== '/') return assetUrl + image;
  return `${assetUrl}/${image}`;
};

export const validEmail = (email: string) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const appendQueryParams = (
  url: string,
  params: Record<string, string>,
): string => {
  const queryString = Object.keys(params)
    .map(
      (key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`,
    )
    .join('&');

  return `${url}${url.includes('?') ? '&' : '?'}${queryString}`;
};

export function pluralize(count: number, singularWord: string): string {
  if (count === 1) {
    return `${count} ${singularWord}`;
  } else {
    // Simple pluralization rule: add 's' to the singular word
    const pluralWord = singularWord + 's';
    return `${count} ${pluralWord}`;
  }
}
